import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import {DadosJwtService} from "../../services/dados-jwt.service";

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private dadosJwtService: DadosJwtService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.dadosJwtService.get().jwt ?? (localStorage.getItem('token') ?? '');
    const cloneReq = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token ?? ''}`)
    });

    return next.handle(cloneReq)
      .pipe(
        tap((resp: HttpEvent<any>) => {
          if (resp instanceof HttpResponse) {
            const xToken = resp.headers.get('x-token')
            if(xToken) {
              this.dadosJwtService.set(xToken);
              localStorage.setItem('token', xToken);
            }
          }
        })
      )

    //Se não houver a chave 'AuthToken' no session storage, apenas prossegue com a requisição//
    return next.handle(request);
  }
}
